import { SET_ENVIRONMENT } from '../actions/actionTypes';
import { EnvironmentAction, Environment } from '../actions/environmentActions';

const STORAGE_KEY = 'app_environment';

function loadEnvironment(): Environment {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'production' || saved === 'staging') return saved;
  } catch { /* ignore */ }
  return 'production';
}

export interface EnvironmentState {
  current: Environment;
}

const initialState: EnvironmentState = {
  current: loadEnvironment(),
};

export default function environmentReducer(
  state: EnvironmentState = initialState,
  action: EnvironmentAction,
): EnvironmentState {
  switch (action.type) {
    case SET_ENVIRONMENT:
      try { localStorage.setItem(STORAGE_KEY, action.payload); } catch { /* ignore */ }
      return { ...state, current: action.payload };
    default:
      return state;
  }
}
